import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { CartService } from '../commons/cart.service';
import { ConfigService } from '../commons/config.service';
import { SessionService } from '../commons/session.service';
import { ProductConfig } from '../commons/models';
import { UtilitiesService } from '../commons/utilities.service';

@Component({

  selector: 'load-product',
  template: require('./load-product.component.html'),
  styles: [`
   .product { margin-bottom:12px; }
   `]
})
export class LoadProductComponent implements OnInit {
  public isImageCatalog: boolean = false;
  constructor(
    private activatedRoute: ActivatedRoute,
    public config: ConfigService,
    private session: SessionService,
    private cartService: CartService,
    private utilities: UtilitiesService,
    private router: Router,
    //public isImageCatalog: boolean = false,
  )
  {

  }


  ngOnInit() {
    // subscribe to router event
    let preFilterKey = null;
    let preFilterValue = null;
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      if (params['preFilterKey']) {
        preFilterKey = params['preFilterKey'];
        //console.log('preFilterKey', preFilterKey);
      }
      if (params['preFilterValue']) {
        preFilterValue = params['preFilterValue'];
        //console.log('preFilterValue', preFilterValue);
      }
    });

    this.activatedRoute.params.subscribe((params: Params) => {

      //PRELOAD IMAGE FROM CATALOG URL
      if (params['urlFileCatalog'] != null) {

        this.isImageCatalog = true;

        //console.log('PRELOAD IMAGE FROM CATALOG URL');
        let urlFileCatalog: string = params['urlFileCatalog'] as string;

        let body = urlFileCatalog;

        this.utilities.requestAngular2('fileChange', body).subscribe(
          result => {
            if (result && result.result === 'ok') {
              this.cartService.cart.currentCartProduct.naturalWidth = result.naturalWidth;
              this.cartService.cart.currentCartProduct.naturalHeight = result.naturalHeight;
              //console.log('result.nameFile: ' + result.nameFile);

              let nameFile = result.nameFile;
              this.cartService.cart.currentCartProduct.photoID = nameFile;
              this.cartService.cart.currentCartProduct.photoOriginal =
                this.config.urlHost + '/files/temp/' + nameFile + '_web.jpg';
              //console.log('photoOriginal: ' + this.cartService.cart.currentCartProduct.photoOriginal);

              this.cartService.cart.currentCartProduct.photoResized = null;
              this.cartService.cart.formatoSelected = false;

              this.cartService.saveCart();

              this.router.navigate(['/upload-photo']);
            } else {
              console.error(result);
              alert('Errore nell caricamento immagine dal catalogo');
            }
          },
          error => {
            console.error(error);
            alert('Errore nell caricamento immagine dal catalogo');
          }
        );
      }


      else if (params['idProduct'] != null) {

        let idProduct: number = params['idProduct'] as number;

        let model: ProductConfig = this.config.products.filter(x => x.id.toString() === idProduct.toString())[0];
        //console.log(model);
        if (model) {
          //console.log('load-product: ' + model.id + ' - ' + model.name);

          this.session.setProduct(model, preFilterKey, preFilterValue);

          this.router.navigate(['/select-products', { preload: model.id, url: model.name.replace(/ /g, '-') }]);

        } else {
          //console.log('nessun config.products trovato');
        }
      }
    });


  }




}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/load-product.component.ts